import { Control, Path, FieldError } from 'react-hook-form';

import { MultiSelectDropdownField } from '../../components';
import { MODES } from '../constants';

const modeOptions = Object.values(MODES);

type ModeListFieldProps<TFormValues> = {
  control: Control<TFormValues>;
  error?: FieldError | FieldError[];
  helperText?: string;
  label?: string;
  name: Path<TFormValues>;
};

export const ModeListField = <TFormValues extends Record<string, unknown>>({
  control,
  error,
  helperText,
  label,
  name,
}: ModeListFieldProps<TFormValues>) => (
  <MultiSelectDropdownField<TFormValues>
    control={control}
    error={error}
    helperText={helperText}
    label={label ?? 'Mode List'}
    name={name}
    options={modeOptions}
  />
);
